import { render, staticRenderFns } from "./ListPorEntregar.vue?vue&type=template&id=40d89359&"
import script from "./ListPorEntregar.vue?vue&type=script&lang=js&"
export * from "./ListPorEntregar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports